import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const ActivityTypeInput = () => {
  const { activityTypeId = '' } = useParams();
  const decodedId = activityTypeId ? atob(activityTypeId) : activityTypeId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'customerActivityType';

  useEffect(() => {
    if (activityTypeId) {
      setIsEditing(true);
      fetchActivityTypeDetails();
    }
  }, [activityTypeId]);

  const fetchActivityTypeDetails = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Token ${token}` };
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customerActivityType}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching activity type details:', error);
    }
  };

  const activityTypeFields = [
    { name: 'name', label: 'Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'textarea' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Activity Type' : 'Create Activity Type'}</h1>
      <FormComponent fields={activityTypeFields} initialFormData={formData} route={route} cancelPath="/customer/activity-type/list" />
    </div>
  );
};

export default ActivityTypeInput;
